import { PAGE_IS_LOADED } from '../actions/pageLoad'

const initialState = {isLoaded:false}
export default (state = initialState, action) => {
    switch(action.type){
        case PAGE_IS_LOADED:
            return{
                ...state,
                    isLoaded:action.payload
            }         
        default:
            return state    
    }
}



// WEBPACK FOOTER //
// ./src/reducers/pageLoad.js